import Countdown from 'react-countdown';
import React from 'react';

export const createCountDownLabel = (days: number, hours: number, minutes: number, seconds: number) => {
  if (days !== 0) return `応募締切まで残り${days}日!!`;
  if (hours !== 0) return `応募締切まで残り${hours}時間${minutes}分${seconds}秒!!`;
  if (minutes !== 0) return `応募締切まで残り${minutes}分${seconds}秒!!`;
  return `応募締切まで残り${seconds}秒!!`;
};

type DeadLineCountDownProps = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  completed: boolean;
  isRecruitmentCompleted: boolean;
};

export const DeadLineCountDown = ({
  days,
  hours,
  minutes,
  seconds,
  completed,
  isRecruitmentCompleted,
}: DeadLineCountDownProps) => {
  const label = createCountDownLabel(days, hours, minutes, seconds);

  if (isRecruitmentCompleted || completed) return null;
  return <div className={'w-full text-center py-1 bg-red text-white font-bold text-sm tracking-wide'}>{label}</div>;
};

type Props = {
  deadLineDate: Date;
  isRecruitmentCompleted: boolean;
};

export const DeadLine = ({ deadLineDate, isRecruitmentCompleted }: Props) => {
  return (
    <Countdown
      date={deadLineDate}
      renderer={({ days, hours, minutes, seconds, completed }) => (
        <DeadLineCountDown
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
          completed={completed}
          isRecruitmentCompleted={isRecruitmentCompleted}
        />
      )}
    />
  );
};
